import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import PublicBooking from "@/pages/PublicBooking";
import Login from "@/pages/Login";
import DriverDashboard from "@/pages/DriverDashboard";
import ClientSpace from "@/pages/ClientSpace";
import PaymentReturn from "@/pages/PaymentReturn";
import { Loader2 } from "lucide-react";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]">
        <Loader2 className="h-6 w-6 animate-spin text-[#39FF14]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "driver" ? "/dashboard" : "/espace"} replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0B0F17]">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicBooking />} />
            <Route path="/login" element={<Login />} />
            <Route path="/payment/success" element={<PaymentReturn />} />
            <Route path="/payment/cancel" element={<PaymentReturn />} />
            <Route path="/dashboard" element={<Protected role="driver"><DriverDashboard /></Protected>} />
            <Route path="/espace" element={<Protected role="client"><ClientSpace /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
